import * as utils from './utils'

export const useUtils = () => {
  return {
    ...utils,
  }
}

export const _ = null
